var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPcBk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 61,
    viewBox: "0 0 316 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_10528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6789 19.3359H43.2363V42.717H46.6789V19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2942 29.2827L48.0215 31.0265L55.2942 32.7703V29.2827Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8988 19.3359H48.416C53.3312 20.0012 56.5154 21.2864 58.8988 23.2304V19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8625 19.3359H64.4199V42.717H67.8625V19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8399 42.7163L72.7459 28.811L70.4336 31.1232L78.0098 42.7163H81.8399Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8031 19.3359C76.8031 19.3359 76.4672 22.4748 74.2324 27.3252L82.222 19.3359H76.8095H76.8031Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8988 38.7256C56.5154 40.6761 53.3312 42.0517 48.416 42.717H58.8988V38.7256Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.052 19.3359H278.609V42.717H282.052V19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.385 19.3359H283.111C289.68 19.9366 293.362 24.5095 293.362 31.0136C293.362 37.5176 289.719 42.1164 283.111 42.717H285.385C291.857 42.717 297.03 37.8858 297.03 31.0136C297.03 24.1413 292.16 19.3359 285.385 19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.899 19.3359H256.463V42.7106H259.899V19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.494 25.2006C272.494 19.956 266.713 19.3359 264.866 19.3359H261.766C262.973 19.5878 268.845 20.2337 268.845 25.2264C268.845 31.4076 262.056 31.6078 262.056 31.6078C263.193 31.6078 264.259 32.1697 264.905 33.1062C268.677 38.6286 266.565 35.5348 271.047 42.6977H275.052L267.643 31.4915C269.755 31.02 272.494 29.0307 272.494 25.207V25.2006Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.708 23.9412C302.708 21.8097 304.129 20.1046 306.674 19.2197C302.895 19.3166 299.834 21.6418 299.834 24.994C299.834 34.0945 313.062 29.3601 313.062 37.0979C313.062 39.7202 311.641 41.8516 308.579 42.8398C312.836 42.7429 316.001 39.9204 316.001 35.8513C316.001 26.5828 302.708 31.1622 302.708 23.9476V23.9412Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.773 24.0636V19.5491C313.481 19.5685 310.335 19.4393 308.869 19.2197C308.869 19.2197 312.686 20.0852 314.773 24.0636Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.77 37.8535V42.5101L306.222 42.8395C302.347 41.6705 300.738 39.0806 299.77 37.8535Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.627 40.8246L233.642 19.3359H230.155L225.627 40.8246Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.848 19.3359L215.959 22.856L212.549 41.1281L217.542 27.8552L222.231 42.717H225.802L218.459 19.3359H214.848Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.877 19.3359L209.19 42.717H212.8L204.449 19.3359H200.877Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44258 19.3359H0V42.717H3.44258V19.3359Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8979 25.278C11.8979 30.6711 5.95572 31.0005 5.03856 31.0328C6.03323 31.0199 12.7375 31.0328 12.7375 36.7748C12.7375 42.5167 5.1742 42.7169 4.82542 42.7169H7.33146C14.3393 42.7169 16.361 39.9654 16.361 36.6908C16.361 33.8424 14.4491 31.5625 9.44997 30.9876C13.2284 30.2965 15.3469 28.094 15.3469 25.3684C15.3469 22.0938 12.8667 19.3423 7.33146 19.3423H4.8125C6.02031 19.5748 11.8914 19.8396 11.8914 25.2844L11.8979 25.278Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.481 42.717L132.187 19.3359H128.176L143.47 42.717H147.481Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.867 42.7164H134.428C130.966 40.3073 128.867 31.0264 128.867 31.0264V42.7164Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.823 31.0259V19.3359H141.262C144.724 21.745 146.823 31.0259 146.823 31.0259Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.701 41.8123V31.02H163.951C163.951 31.02 167.426 32.0986 167.426 35.6573V41.8446C167.949 41.7154 169.803 41.3279 170.701 41.8123Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.223 42.478C158.945 42.8784 154.747 38.8029 154.747 30.7551C154.747 24.7419 156.472 20.2659 161.613 19C155.303 19 150.717 24.2769 150.717 31.0199C150.717 39.7007 157.776 44.6805 165.223 42.478Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.559 23.9279V19.3358C169.222 19.3552 165.967 19.2196 164.449 19C164.449 19 168.932 20.1625 170.559 23.9279Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1875 37.8984V42.5874L92.6399 42.9167C88.7646 41.7348 87.1563 39.132 86.1875 37.8984Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.191 24.012V19.4651C99.8987 19.4845 96.7533 19.3553 95.2871 19.1357C95.2871 19.1357 99.1043 20.0076 101.191 24.012Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1203 23.8963C89.1203 21.752 90.5412 20.0339 93.086 19.1426C89.3076 19.2395 86.2461 21.584 86.2461 24.9556C86.2461 34.1207 99.4738 29.354 99.4738 37.1434C99.4738 39.7851 98.0529 41.9359 94.9914 42.9241C99.2478 42.8272 102.413 39.9853 102.413 35.8904C102.413 26.5574 89.1203 31.169 89.1203 23.9028V23.8963Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0034 24.4126L18.4336 42.7161H22.5996L26.0034 24.4126Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9347 36.1807L35.2663 42.717H38.8768L30.5255 19.3359H26.915L32.024 33.6423L26.3789 34.8178L32.9347 36.1807Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.003 24.4126L104.434 42.7161H108.6L112.003 24.4126Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.933 36.1807L121.264 42.717H124.875L116.524 19.3359H112.913L118.022 33.6423L112.377 34.8178L118.933 36.1807Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.089 19.3359L194.204 33.6423L188.553 34.8178L195.108 36.1807L197.44 42.717H201.051L192.699 19.3359H189.089Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.775 42.7161L188.179 24.4126L180.609 42.7161H184.775Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.058 19.3359L246.173 33.6423L240.521 34.8178L247.077 36.1807L249.409 42.717H253.019L244.668 19.3359H241.058Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.744 42.7161L240.148 24.4126L232.578 42.7161H236.744Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_10528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 24.0011,
    fill: "white",
    transform: "translate(0 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPcBk);
export default __webpack_public_path__ + "static/media/logo_pc_bk.fee5b62e74633b06c2a24995aa12578c.svg";
export { ForwardRef as ReactComponent };